import React from 'react';
import strings from 'utils/strings';
import classNames from 'classnames';
import './styles.scss';
class NewClassModal extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			className: '',
			isCreatingNewClass: true,
			targetGroup: '',
			isAddingGroup: false,
			groupId: null,
			isAddingCandidates: false,
			inclusiveMember: [],
			exclusiveMembers: [],
			inclusiveIds: [],
			targetClass: '',
		};
		this.excludeMembersIfExists = this.excludeMembersIfExists.bind(this);
	}
	componentDidMount() {}
	determineGender(currentTestUser, allTestUsers) {
		for (let i = 0; i < allTestUsers.length; i++) {
			const testsResults = allTestUsers[i].testResults;
			for (let j = 0; j < testsResults.length; j++) {
				if (testsResults[j].testUser) {
					if (
						testsResults[j].testUser.testUserId ===
							currentTestUser &&
						testsResults[j].info
					) {
						const information = JSON.parse(testsResults[j].info);
						if (testsResults[j].type !== 'child') {
							if (information.gender === 'm') {
								return (
									<td className="lit-list-users-new-group-col">
										{strings.common.male}
									</td>
								);
							} else {
								return (
									<td className="lit-list-users-new-group-col">
										{strings.common.female}
									</td>
								);
							}
						} else if (information.gender === 'm') {
							return (
								<td className="lit-list-users-new-group-col">
									{strings.common.boy}
								</td>
							);
						} else if (information.gender === 'f') {
							return (
								<td className="lit-list-users-new-group-col">
									{strings.common.girl}
								</td>
							);
						}
					}
				}
			}
		}
		return null;
	}
	setDefaultUser(filteredTestUsers, adminClasses, classData, currentUser) {
		const userClasses = adminClasses.map((userClass) => {
			return userClass.className;
		});
		const defaultClass = [
			...new Set(
				classData
					.filter((userClass) => userClass.ownsClass)
					.map((userClass) => userClass.className)
			),
		];

		if (!defaultClass.length) {
			this.setState({
				exclusiveMembers: [],
				inclusiveMember: [],
				targetClass: '',
			});
			return;
		}

		this.excludeMembersIfExists(
			defaultClass[0],
			classData,
			filteredTestUsers,
			currentUser
		);
	}

	async excludeMembersIfExists(
		value,
		classMembers,
		selectedTestUsers,
		currentUser
	) {
		const {subscription} = currentUser;
		const selectedTestUserIds = selectedTestUsers.map((TestUser) => {
			return {
				testUser: TestUser.id,
				firstName: TestUser.firstName,
				lastName: TestUser.lastName,
			};
		});
		var getrelevantData = classMembers.filter(
			(userClass) => userClass.className === value
		);

		const candidates = getrelevantData[0].classInfo;

		let flag = null;
		let currentClassId = null;
		const temObj = [];
		const permObj = [];
		for (let i = 0; i < selectedTestUserIds.length; i++) {
			flag = 0;
			for (let j = 0; j < candidates.length; j++) {
				if (
					selectedTestUserIds[i].testUser ===
					candidates[j].candidateId
				) {
					flag = 1;
					const matched = {
						Name:
							selectedTestUserIds[i].firstName +
							' ' +
							selectedTestUserIds[i].lastName,
					};

					temObj.push(matched);
				} else {
					currentClassId = candidates[j].classId;
				}
			}
			if (flag !== 1) {
				const unMatched = {
					testUser: selectedTestUserIds[i].testUser,
					class: currentClassId,
					subscription: subscription.id,
					adminid: currentUser.id,
				};
				permObj.push(unMatched);
			}
		}
		this.setState({
			exclusiveMembers: permObj,
			targetClass: currentClassId,
			inclusiveMember: temObj,
		});
	}

	getCandidateGenderLabel(currentTestUser, allTestUsers) {
		for (let i = 0; i < allTestUsers.length; i++) {
			const testsResults = allTestUsers[i].testResults;

			for (let j = 0; j < testsResults.length; j++) {
				if (
					testsResults[j].testUser &&
					testsResults[j].testUser.testUserId === currentTestUser &&
					testsResults[j].info
				) {
					const information = JSON.parse(testsResults[j].info);

					if (testsResults[j].type !== 'child') {
						return information.gender === 'm'
							? strings.common.male
							: strings.common.female;
					}

					if (information.gender === 'm') return strings.common.boy;
					if (information.gender === 'f') return strings.common.girl;
				}
			}
		}

		return '-';
	}

	setCreateMode() {
		this.setState({
			isCreatingNewClass: true,
			isDeletingCandidates: false,
			isAddingCandidates: false,
			inclusiveMember: [],
			exclusiveMembers: [],
			targetClass: '',
		});
	}

	setExistingClassMode(filteredTestUsers) {
		this.setState(
			{
				isCreatingNewClass: false,
				isDeletingCandidates: false,
				isAddingCandidates: true,
			},
			() => {
				this.setDefaultUser(
					filteredTestUsers,
					this.props.adminClasses,
					this.props.classData,
					this.props.currentUser
				);
			}
		);
	}

	render() {
		const {subscription} = this.props.currentUser;
		const filteredTestUsers = this.props.selectedTestCandidates || [];
		const hasAdminClasses = Boolean(this.props.adminClasses.length);
		const isExistingClassMode =
			!this.state.isCreatingNewClass && this.state.isAddingCandidates;

		const ownedClasses = this.props.classData.filter(
			(adminClass) => adminClass.ownsClass
		);

		return (
			<div
				className="ncm-modal"
				onClick={() => {
					this.props.closeWindow();
				}}
			>
				<div
					className="ncm-modal__island"
					onClick={(event) => {
						event.stopPropagation();
					}}
				>
					<div className="ncm-header">
						<div>
							<h3 className="ncm-title">{strings.classes.skapaKlassEllerLaggTill}</h3>
							<p className="ncm-subtitle">
								{filteredTestUsers.length} {strings.classes.valdaKandidater}
							</p>
						</div>

						<button
							type="button"
							className="ncm-close"
							onClick={this.props.closeWindow}
							aria-label="Close"
						>
							×
						</button>
					</div>

					<div className="ncm-body">
						<section className="ncm-card">
							<div className="ncm-card__header">
								<div>
									<h4 className="ncm-card__title">
										{strings.classes.valdaKandidater_ReverseCamelCase}
									</h4>
									<p className="ncm-card__subtitle">
										{strings.classes.dessaKandidaterKommerAttLaggasTillIKlassen}
									</p>
								</div>
							</div>

							<div className="ncm-table-wrap">
								<table
									id="testUsers_table"
									className="ncm-table"
								>
									<thead>
										<tr>
											<th>
												{strings.common.firstname +
													', ' +
													strings.common.lastname}
											</th>
											<th>{strings.common.email}</th>
											<th>{strings.common.telephone}</th>
											<th>{strings.common.gender}</th>
										</tr>
									</thead>

									<tbody>
										{filteredTestUsers.map((testUser) => (
											<tr key={testUser.id}>
												<td>
													<strong>
														{testUser.firstName
															? `${testUser.firstName} ${testUser.lastName}`
															: '-'}
													</strong>
												</td>
												<td>{testUser.email || '-'}</td>
												<td>{testUser.phone || '-'}</td>
												<td>
													{this.getCandidateGenderLabel(
														testUser.id,
														this.props
															.batchedFilteredTestResults
													)}
												</td>
											</tr>
										))}
									</tbody>
								</table>
							</div>
						</section>

						<section className="ncm-card ncm-form-card">
							<h4 className="ncm-card__title">{strings.classes.valjAtgard}</h4>

							<div className="ncm-mode-grid">
								<button
									type="button"
									className={classNames('ncm-mode-card', {
										'ncm-mode-card--active':
											this.state.isCreatingNewClass,
									})}
									onClick={() => this.setCreateMode()}
								>
									<span className="ncm-mode-card__title">
										{strings.classes.skapaNyKlass}
									</span>
									<span className="ncm-mode-card__text">
										{strings.classes.skapaNyKlassMedValdaKandidater}
									</span>
								</button>

								{hasAdminClasses && (
									<button
										type="button"
										className={classNames('ncm-mode-card', {
											'ncm-mode-card--active':
												isExistingClassMode,
										})}
										onClick={() =>
											this.setExistingClassMode(
												filteredTestUsers
											)
										}
									>
										<span className="ncm-mode-card__title">
											{strings.classes.addToExistingClass}
										</span>
										<span className="ncm-mode-card__text">
											{strings.classes.valjKlassDuAgerOchLaggTillKandidaternaDar}
										</span>
									</button>
								)}
							</div>

							{this.state.isCreatingNewClass &&
								!this.state.isAddingCandidates && (
									<div className="ncm-field">
										<label className="ncm-label">
											{strings.classes.klassnamn}
										</label>
										<input
											className="ncm-input"
											type="text"
											placeholder={strings.classes.writeclassname}
											value={this.state.className}
											onChange={(e) => {
												this.setState({
													className: e.target.value,
												});
											}}
										/>
									</div>
								)}

							{isExistingClassMode && (
								<div className="ncm-field">
									<label className="ncm-label">
										{strings.classes.chooseclass}
									</label>

									<select
										className="ncm-input"
										name="group"
										disabled={!ownedClasses.length}
										onChange={(event) => {
											this.excludeMembersIfExists(
												event.target.value,
												this.props.classData,
												filteredTestUsers,
												this.props.currentUser
											);
										}}
									>
										{ownedClasses.length ? (
											ownedClasses.map((adminClass) => (
												<option
													key={adminClass.classId}
													id={adminClass.classId}
													value={adminClass.className}
												>
													{adminClass.className}
												</option>
											))
										) : (
											<option>
												{strings.classes.ingaklassertillgangliga}
											</option>
										)}
									</select>

									{Boolean(
										this.state.inclusiveMember.length
									) && (
										<p className="ncm-help ncm-help--warning">
											{this.state.inclusiveMember.length}{' '}
											kandidat(er) finns redan i den valda
											klassen.
										</p>
									)}
								</div>
							)}
						</section>
					</div>

					<div className="ncm-actions">
						<button
							type="button"
							className="lit-btn bg-negative2 ncm-action-btn"
							onClick={this.props.closeWindow}
						>
							{strings.common.cancel}
						</button>

						{isExistingClassMode ? (
							<button
								type="button"
								className={classNames(
									'print-hide',
									'lit-btn',
									'see-more',
									'bg-tertiary',
									'ncm-action-btn'
								)}
								disabled={!this.state.exclusiveMembers.length}
								onClick={() => {
									if (this.state.inclusiveMember.length) {
										let existingMembers = '';

										for (const property of this.state
											.inclusiveMember) {
											existingMembers +=
												JSON.stringify(
													Object.values(property)
												).replace(/[\[\]"]+/g, '') +
												', ';
										}

										window.alert(
											existingMembers +
												strings.classes.alreadyexistsingroup
										);
									}

									if (this.state.exclusiveMembers.length) {
										this.props.onAddingCandidates(
											this.state.exclusiveMembers
										);
									}
								}}
							>
								{strings.common.insert}
							</button>
						) : (
							<button
								type="button"
								className={classNames(
									'print-hide',
									'lit-btn',
									'see-more',
									'bg-tertiary',
									'ncm-action-btn'
								)}
								onClick={() => {
									if (this.state.className.trim().length) {
										const className =
											this.state.className.trim();
										const adminId =
											this.props.currentUser.id;
										const subsId = subscription.id;
										const usersIds = filteredTestUsers.map(
											(testUser) => testUser.id
										);

										this.props.onCreateClass(
											usersIds,
											adminId,
											subsId,
											className,
											this.state.groupId
										);
									} else {
										window.alert(strings.classes.writegroupname);
									}
								}}
							>
								{strings.classes.newclass}
							</button>
						)}
					</div>
				</div>
			</div>
		);
	}
}
export default NewClassModal;
